import { getParams } from '@/utils/url'
import browser from '@/utils/browser'
import { getLocalWeChatOpenids, setLocalWeChatOpenids, } from '@/utils/storage'

import { getWxAuthOpenid } from '@/service'

const errcode = ['40029','40028']

const handleWeChatEnv = (appID = 'wxb02f1c7c5154290c') => {
    console.log('在微信环境内：', browser.inWxEnv)
    let pageUrl = location.href
    if (browser.inWxEnv && !/chargecenter/g.test(pageUrl.toLowerCase())) {
        console.log('handling wechat env')

        const appid_openids = getLocalWeChatOpenids()
        let appid_openid = {}
        appid_openids.forEach(item => {
            if (item.openid) {
                appid_openid[item.appid] = item
            }
        })

        console.log('appid_openid', appid_openid)
        //本地存储没有APPID对应的openid才会进行网页授权
        if (!appid_openid[appID]) {

            const urlCodeParam = getParams('code')
            const game_id = getParams('game_id')
            if (urlCodeParam) {
                console.log('auth_code', urlCodeParam)

                getWxAuthOpenid({
                    game_id: game_id,
                    code: urlCodeParam,
                }).then(res => {
                    console.log('getWxAuthOpenid res', res)
                    if (res.code == 0) {
                        appid_openid[appID] = { appid: appID, openid: res.data.openid }
                        setLocalWeChatOpenids(Object.values(appid_openid))
                    } else {
                        for(let i in errcode){
                            if(res.indexOf('errcode') > -1 && res.indexOf(errcode[i]) > -1){
                                //把链接上的无效的code去掉
                                pageUrl = pageUrl.replace(`&code=${urlCodeParam}&state=`, '')
                                //    跳转先微信授权登录
                                const wxAuthorizeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
                                const redirectURL = encodeURIComponent(pageUrl)
                                const appid = appID
                                const restParams = 'response_type=code&scope=snsapi_base'
                                const authorUrl = `${wxAuthorizeUrl}?appid=${appid}&redirect_uri=${redirectURL}&${restParams}#wechat_redirec`
                                console.log('authorUrl', authorUrl)
                                window.location.href = authorUrl

                                return
                            }
                        }
                    }
                })

            } else {
                //    跳转先微信授权登录
                const wxAuthorizeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
                const redirectURL = encodeURIComponent(pageUrl)
                const appid = appID
                const restParams = 'response_type=code&scope=snsapi_base'
                const authorUrl = `${wxAuthorizeUrl}?appid=${appid}&redirect_uri=${redirectURL}&${restParams}#wechat_redirec`
                console.log('authorUrl', authorUrl)
                window.location.href = authorUrl
            }
        }

    }
}

export default handleWeChatEnv
